import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { FirstChangePasswordRepresentativeCommandRequest } from 'domain/entities/authUser'

export const FirstChangeRepresentativeCommand = (
  repository: IRepresentativeRepository,
  data: FirstChangePasswordRepresentativeCommandRequest,
) => {
  return repository.firstChangePass(data)
}
